var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C15.84 0 31.68 0 48 0 C48 1.98 48 3.96 48 6 C32.16 6 16.32 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#000000",
    transform: "translate(8,43)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C15.84 0 31.68 0 48 0 C48 1.98 48 3.96 48 6 C32.16 6 16.32 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#000000",
    transform: "translate(8,29)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C15.84 0 31.68 0 48 0 C48 1.98 48 3.96 48 6 C32.16 6 16.32 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#000000",
    transform: "translate(8,15)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.57548228b53353a7de123711f8886921.svg";
export { ForwardRef as ReactComponent };